import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IIksAddRequest {
  merchantId: number;
}

async function addIks(data: IIksAddRequest): Promise<any> {
  try {
    // URL'e query parametresi ekleyerek request'i gönderiyoruz.
    return (await axiosInstance.post(`/MerchantIKS/Add?merchantId=${data.merchantId}`)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useAddIks() {
  return useMutation<any, Error, IIksAddRequest>((variables) =>
    addIks(variables)
  );
}
